module.exports = __webpack_public_path__ + "static/img/y58.7950286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y58.jpg
// module id = gefC
// module chunks = 1